import * as React from 'react';
import {useState} from 'react';


import './style.scss';

import {A} from 'components/atoms/LinksAndButtons/A';
import {Icon} from 'components/atoms/Media/Icon';
import {Scrollbox} from 'components/molecules/TextShowHide/Scrollbox';
import {sanitizeHtml} from 'features/services/utils/sanitize-html';
import {RealEstateAgent} from "features/template/viewModels/ResidenceStage";
import {InterestForm} from "components/forms/InterestForm";

interface Props {
    stageName: string;
    stageId: string;
    stageStatus: string;
    objectId?: string;
    premises?: boolean;

    agent?: RealEstateAgent;
    interestType: string;

    interestDone?: boolean;
    setInterestDone?: (done: boolean) => void;
    hideMessageField: boolean;
    basicSignupPulText: string;
    labelPrefix: string;

    doneCallback?: () => void;
}

enum ModalState {
    FORM = 'form',
    PUL = 'pul',
}

export const InterestFormModal: React.FunctionComponent<Props> = ({
    stageName, stageId, stageStatus, objectId, premises,
    interestType: _interestType, agent,
    interestDone, setInterestDone,
    hideMessageField, basicSignupPulText, labelPrefix: _labelPrefix,
    doneCallback
}) => {
    const [modalState, setModalState] = useState<ModalState>(ModalState.FORM);


    const _onPulLinkClick = () => {
        setModalState(ModalState.PUL);
    };

    const onBackClick = (e: React.SyntheticEvent) => {
        e.preventDefault();
        setModalState(ModalState.FORM);
    };

    return (
        <div className="interest-form-modal">
            {modalState === ModalState.FORM &&
                <InterestForm
                    stageName={stageName}
                    agent={agent}
                    stageId={stageId}
                    objectId={objectId}
                    stageStatus={stageStatus}
                    premises={premises}
                    //interestType={interestType}
                    hideMessageField={hideMessageField}
                    onSubmitCallback={doneCallback}
                    //basicSignupPulText={basicSignupPulText}
                    //onPulTextCallback={onPulLinkClick}
                    //labelPrefix={labelPrefix}
                    interestDone={interestDone}
                    setInterestDone={setInterestDone}
                />
            }

            {modalState === ModalState.PUL &&
                <div className="interest-form-modal__pul">
                    <div className="interest-form-modal__pul-top">
                        <A 
                            href="#" 
                            onClick={onBackClick} 
                            title='Tillbaka till intresseanmälan' 
                        >
                            <Icon name="chevron" left />Tillbaka till intresseanmälan
                        </A>
                    </div>

                    <Scrollbox>
                        <div dangerouslySetInnerHTML={{__html: sanitizeHtml(basicSignupPulText)}}/>
                    </Scrollbox>
                </div>
            }
        </div>
    );
};

/*
<InterestForm
                    stageName={stageName}
                    agent={agent}
                    stageId={stageId}
                    objectId={objectId}
                    stageStatus={stageStatus}
                    //interestType={interestType}
                    hideMessageField={hideMessageField}
                    onSubmitCallback={doneCallback}
                    //basicSignupPulText={basicSignupPulText}
                    //onPulTextCallback={onPulLinkClick}
                    //labelPrefix={labelPrefix}
                    interestDone={interestDone}
                    setInterestDone={setInterestDone}
                />
 */
